import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getRackModel = (storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/rack-config/' + storeId,
    headers: getHeaders(),
  });
};

export const getRackManualModel = (storeId) => {
   return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-rack/' + storeId,
    headers: getHeaders(),
  });
};

export const postRackManualModel = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store-rack/' + storeId,
    data,
    headers: getHeaders(),
  });
};
 